import { render } from "./Language.vue?vue&type=template&id=491451fd&scoped=true"
import script from "./Language.vue?vue&type=script&lang=js"
export * from "./Language.vue?vue&type=script&lang=js"

import "./Language.vue?vue&type=style&index=0&id=491451fd&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-491451fd"

export default script